import { useMemo } from 'react'
import { Col, Row } from 'antd'
import get from 'lodash/get'
import PropTypes from 'prop-types'

import { ImageType } from '../types'
import ExpandIcon from './ExpandIcon'
import { BlockSectionTitle, BlockWrapper, BynderPicture, Collapse, Container, Panel, Typography } from 'common/widgets'
import classNames from './styles.module.scss'


Accordion.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.string,
    heading_hx: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
      question: PropTypes.string,
      answer: PropTypes.string,
    })),
    image: ImageType,
  }),
  priorityLoad: PropTypes.bool,
}

function AccordionAnswer({ answer }) {
  return (
    <Typography
      color="light-black"
      tag="div"
      dangerouslySetInnerHTML={{ __html: answer }}
      className={classNames.baseStyles}
    />
  )
}

AccordionAnswer.propTypes = {
  answer: PropTypes.string.isRequired,
}

export default function Accordion({
  data = {},
  priorityLoad = false,
}) {
  const itemsData = data.items || []
  const readerOnlyItems = useMemo(() => itemsData.map(({ question, question_hx: questionHx, answer }, idx) => (
    <div key={idx}>
      <Typography variant="subhead" tag={questionHx || 'h3'} className={classNames.title}>
        {question}
      </Typography>
      <AccordionAnswer answer={answer} />
    </div>
  )), [itemsData])
  const items = useMemo(() => itemsData.map(({ question, question_hx: questionHx, answer }, idx) => (
    <Panel
      key={idx}
      isClassless
      forceRender
      header={<Typography
        variant="subhead"
        tag={questionHx}
        className={classNames.title}
      >
        {question}
      </Typography>}
      className={classNames.panel}
    >
      <AccordionAnswer answer={answer} />
    </Panel>
  )), [itemsData])
  const image = useMemo(() => get(data, 'image'), [data.image])

  return (
    <BlockWrapper>
      <Container size="xl">
        <BlockSectionTitle heading={data.heading} headingHx={data.heading_hx} />
        <Row gutter={[{ lg: 40 }]} align="stretch">
          <Col span={24} md={16}>
            <Collapse accordion expandIcon={ExpandIcon}>
              {items}
            </Collapse>
          </Col>
          {image && (
            <Col
              span={24}
              md={8}
            >
              <BynderPicture
                image={image}
                className={classNames.image}
                priority={priorityLoad}
                desktopImage={{
                  maxWidth: 600,
                  maxHeight: 450,
                  sizes: '33vw',
                }}
              />
            </Col>
          )}
        </Row>
        <section aria-label="FAQ" className={classNames.readerOnly}>
          {readerOnlyItems}
        </section>
      </Container>
    </BlockWrapper>
  )
}
